<template>
  <div class="msgwrp">
    <div class="textmsg">
      <div class="quotedmsg" v-if="data.quotedText">{{ data.quotedText }}</div>
      <span v-html="messageText"></span>
      <a
        class="quoteBtn"
        v-if="canQuote"
        title="引用回覆"
        @click="quote"
      >引用</a>
    </div>
  </div>
</template>

<script>
import Global from "@/components/Global";
import store from "@/vuex/store_chat.js";
export default {
  props: ["data"],
  computed: {
    messageText() {
     return this.data.Text.replace(/\n|\r\n/g,"<br/>");
    },
    canQuote() {
      //僅客戶的文字訊息可被引用
      return this.data.senderType === 1 && this.data.Hid;
    }
  },
  methods: {
    quote() {
      store.dispatch("SetQuoteTarget", {
        messageId: this.data.Hid,
        text: this.data.Text,
        userName: this.data.UserName
      });
    }
  }
};
</script>
<style>
.textmsg .quotedmsg {
  border-left: 3px solid #999;
  padding: 2px 6px;
  margin-bottom: 4px;
  color: #666;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}
.textmsg .quoteBtn {
  display: none;
  margin-left: 6px;
  font-size: 12px;
  color: #409eff;
  cursor: pointer;
}
.textmsg:hover .quoteBtn {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/ChatMessageText.vue